import gql from 'graphql-tag';

export const CONFIRM_FACEBOOK_IMPORT_REQUEST_MUTATION = gql`
  mutation ConfirmFacebookImportRequestMutation($requestId: Int!) {
    confirmFacebookImportRequest(requestId: $requestId) {
      errors
    }
  }
`;
